import CompraUpdate from './CompraUpdate'
export {CompraUpdate}
export default CompraUpdate
